/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResponseGetAllBasesResponse
 */
export interface ResponseGetAllBasesResponse {
    /**
     * 
     * @type {number}
     * @memberof ResponseGetAllBasesResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetAllBasesResponse
     */
    mail?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetAllBasesResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetAllBasesResponse
     */
    phoneNum?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetAllBasesResponse
     */
    post?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetAllBasesResponse
     */
    postNum?: string;
}

/**
 * Check if a given object implements the ResponseGetAllBasesResponse interface.
 */
export function instanceOfResponseGetAllBasesResponse(value: object): value is ResponseGetAllBasesResponse {
    return true;
}

export function ResponseGetAllBasesResponseFromJSON(json: any): ResponseGetAllBasesResponse {
    return ResponseGetAllBasesResponseFromJSONTyped(json, false);
}

export function ResponseGetAllBasesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseGetAllBasesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'mail': json['mail'] == null ? undefined : json['mail'],
        'name': json['name'] == null ? undefined : json['name'],
        'phoneNum': json['phone_num'] == null ? undefined : json['phone_num'],
        'post': json['post'] == null ? undefined : json['post'],
        'postNum': json['post_num'] == null ? undefined : json['post_num'],
    };
}

export function ResponseGetAllBasesResponseToJSON(json: any): ResponseGetAllBasesResponse {
    return ResponseGetAllBasesResponseToJSONTyped(json, false);
}

export function ResponseGetAllBasesResponseToJSONTyped(value?: ResponseGetAllBasesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'mail': value['mail'],
        'name': value['name'],
        'phone_num': value['phoneNum'],
        'post': value['post'],
        'post_num': value['postNum'],
    };
}

